export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11811.5f221ffc.jpg";